import VacancyCard from './VacancyCard';
export default VacancyCard;